import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { SLIDER_PROGRESS_BAR_HEIGHT, SLIDER_TICK_COLOR } from '../constants';
import { getPercent } from '../../../helpers/common';
import { sizeMixin } from '../../../mixins/layout';
import { pointerEventsNoneStyle } from '../../../tokens/pointer-events';
const TickDot = styled.span`
  position: absolute;
  display: block;
  left: ${({
  $percent
}) => getPercent($percent)};
  top: 50%;
  z-index: 2;
  border-radius: 50%;
  background-color: ${SLIDER_TICK_COLOR};
  transform: translate(-50%, -50%);
  ${({
  $first
}) => $first && `transform: translate(0%, -50%);`}
  ${({
  $last
}) => $last && `transform: translate(-100%, -50%);`}
  ${sizeMixin}
  ${pointerEventsNoneStyle}
`;
export const SliderTickDot = ({
  tick,
  size = SLIDER_PROGRESS_BAR_HEIGHT,
  ...props
}) => {
  const {
    percent
  } = tick;
  return /*#__PURE__*/React.createElement(TickDot, _extends({
    $size: size,
    $percent: percent,
    $first: percent === 0,
    $last: percent === 100
  }, props));
};